import { IAccountCrudModalLang } from '../../../types/lang'

export const accountCrudModalLang: IAccountCrudModalLang = {
	account_crud_modal: {
		title_create: 'Create account_ua',
		title_edit: 'Edit account_ua',
		title_clone: 'Clone account from base account_ua',
		title_deleted: 'Deleted accounts_ua',
		title_remove_single: 'Remove <span>account_ua</span>',
		title_remove_multiple: 'Remove <span>accounts_ua</span>',
		title_remove_multiple_cnt: 'Remove <span>{{cnt}} selected account(s)_ua</span>',
		field_email_label: 'Email_ua',
		field_email_placeholder: 'Email_ua',
		field_is_active_label: 'Active_ua',
		field_is_active_placeholder: 'Active_ua',
		field_is_fired_label: 'Fired_ua',
		field_role_label: 'Role_ua',
		field_role_placeholder: 'Role_ua',
		field_login_label: 'Login_ua',
		field_login_placeholder: 'Login_ua',
		field_password_label: 'Password_ua',
		field_password_placeholder: 'Password_ua',
		field_kt_group_label: 'KT Group_ua',
		field_kt_group_placeholder: 'KT Group_ua',
		field_date_registered_label: 'Date Registered_ua',
		field_date_registered_placeholder: 'Date Registered_ua',
		msg_remove_confirm: 'Are you sure?_ua',
		msg_resurrect_success: 'Account {{account}} is resurrected successfully!_ua',
		msg_resurrect_error: 'Account {{account}} was NOT resurrected._ua',
		btn_create: 'Create_ua',
		btn_update: 'Save_ua',
		btn_clone: 'Clone_ua',
		btn_remove: 'Remove_ua',
		btn_close: 'Close_ua'
	}
}